import axios from "axios"
import { InvoicesApi, DraftsApi, NumberRangesApi, UsersApi, ReverseInvoicesApi, CarsApi, VersionsApi, AuditTrailApi, InvoiceRemindersApi, XmlInvoicesApi, CustomersApi } from "./GeneratedClients/FreeBillApi"
import Cookies from "js-cookie"

const apiUrl = process.env.REACT_APP_DATA_PROVIDER_URL ? process.env.REACT_APP_DATA_PROVIDER_URL : 'http://localhost:5164'

const authToken = () => {
  return Cookies.get('Authorization')
}

const axiosInstance = () => axios.create({
  validateStatus: (status: number) => {
    return (status >= 200 && status < 300) || status === 404
  },
  headers: {Authorization: authToken()}
})

const refresh = () => {
  apiService.InvoicesApi = new InvoicesApi(undefined, apiUrl, axiosInstance())
  apiService.ReverseInvoicesApi = new ReverseInvoicesApi(undefined, apiUrl, axiosInstance())
  apiService.InvoiceRemindersApi = new InvoiceRemindersApi(undefined, apiUrl, axiosInstance())
  apiService.DraftsApi = new DraftsApi(undefined, apiUrl, axiosInstance())
  apiService.NumberRangesApi = new NumberRangesApi(undefined, apiUrl, axiosInstance())
  apiService.UsersApi = new UsersApi(undefined, apiUrl, axiosInstance())
  apiService.CustomersApi = new CustomersApi(undefined, apiUrl, axiosInstance())
  apiService.CarsApi = new CarsApi(undefined, apiUrl, axiosInstance())
  apiService.VersionsApi = new VersionsApi(undefined, apiUrl, axiosInstance())
  apiService.AuditTrailApi = new AuditTrailApi(undefined, apiUrl, axiosInstance())
  apiService.XmlInvoicesApi = new XmlInvoicesApi(undefined, apiUrl, axiosInstance())
}

const apiService = {
  InvoicesApi: new InvoicesApi(undefined, apiUrl, axiosInstance()),
  ReverseInvoicesApi: new ReverseInvoicesApi(undefined, apiUrl, axiosInstance()),
  InvoiceRemindersApi: new InvoiceRemindersApi(undefined, apiUrl, axiosInstance()),
  DraftsApi: new DraftsApi(undefined, apiUrl, axiosInstance()),
  NumberRangesApi: new NumberRangesApi(undefined, apiUrl, axiosInstance()),
  UsersApi: new UsersApi(undefined, apiUrl, axiosInstance()),
  CustomersApi: new CustomersApi(undefined, apiUrl, axiosInstance()),
  CarsApi: new CarsApi(undefined, apiUrl, axiosInstance()),
  VersionsApi: new VersionsApi(undefined, apiUrl, axiosInstance()),
  AuditTrailApi: new AuditTrailApi(undefined, apiUrl, axiosInstance()),
  XmlInvoicesApi: new XmlInvoicesApi(undefined, apiUrl, axiosInstance()),
  refresh: refresh
}

export {apiService, axiosInstance}